'use strict';

angular.module('mean.inspinia').factory('aceUtils', [ '$filter',
  	function($filter) {

        var isUndefinedOrNull = function(obj) {
            return !angular.isDefined(obj) || obj===null;
        };

        var isUndefinedOrZero = function(obj) {
            return !angular.isDefined(obj) || obj===0;
        };

        var padDigits = function(number, digits) {
	        return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
        }
        
        var isValidEmail = function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
          }

        return {
            isUndefinedOrNull: isUndefinedOrNull,
            isUndefinedOrZero: isUndefinedOrZero,
            padDigits: padDigits,
            isValidEmail: isValidEmail
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/inspinia/public/services/ace-utils.js